<template>
  <v-container>
    <v-tabs v-model="activeTab" background-color="primary" dark>
      <v-tab @click="navigateToTab('templates')">Templates</v-tab>
      <v-tab @click="navigateToTab('communication')">Communications</v-tab>
    </v-tabs>

    <v-tabs-items v-model="activeTab">
      <!-- TAB 1: Templates -->
      <v-tab-item>
    <v-card>
      <v-card-title class="d-flex align-center">
        <v-icon
          color="primary"
          @click="openEditDialog(null)"
          style="cursor: pointer"
          >add</v-icon
        >
        <v-divider vertical class="mx-2" />
        <v-select
          v-model="selectedType"
          :items="uniqueTypes"
          label="Filter by Type"
          clearable
          dense 
          style="max-width: 200px"
        />
        <v-divider vertical class="mx-2" />
        <v-select
          v-model="selectedIndustry"
          :items="uniqueIndustry"
          label="Filter by Industry"
          clearable
          dense
          style="max-width: 200px"
        />
        <v-divider vertical class="mx-2" />
        <v-select
          v-model="selectedState"
          :items="uniqueState"
          label="Filter by State"
          clearable
          dense
          style="max-width: 200px"
        />
        <v-divider vertical class="mx-2" />
        <v-checkbox
          v-model="myClubOnly"
          label="My Club Only"
          class="mt-2"
        />

      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="filteredTemplates"
        :loading="loading"
        item-value="seqNo"
        class="elevation-1"
        :items-per-page="50"
        sort-by="updateDate"
        sort-desc         
      >
        <template #item.body="{ item }">
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on" class="text-truncate">
                {{ truncateText(stripHtml(item.body), 30) }}
              </div>
            </template>
            <span>{{ stripHtml(item.body) }}</span>
          </v-tooltip>
        </template>

        <template #item.actions="{ item }">
                    <!-- v-menu that is triggered by the three dots button -->
                    <v-menu offset-y open-on-hover>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn x-small color="primary" dark v-bind="attrs" v-on="on">
                          <v-icon small>more_vert</v-icon>
                        </v-btn>
                      </template>
                      <!-- Menu content (will only be visible when the menu is active) -->
                      <v-list>
                        <!-- Edit Action -->
                        <v-list-item @click="openSendDialog(item)"">
                          <v-list-item-icon>
                            <v-icon>send</v-icon>
                            <!-- Edit icon -->
                          </v-list-item-icon>
                          <v-list-item-title>Run Template </v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="openEditDialog(item)">
                          <v-list-item-icon>
                            <v-icon>edit</v-icon>
                            <!-- Edit icon -->
                          </v-list-item-icon>
                          <v-list-item-title>Edit</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="duplicateTemplate(item)">
                          <v-list-item-icon>
                            <v-icon>control_point_duplicate</v-icon>
                            <!-- Edit icon -->
                          </v-list-item-icon>
                          <v-list-item-title>Duplicate</v-list-item-title>
                        </v-list-item>

                        <!-- <v-btn x-small @click="sendEmail(item.node)">
                    {{ item.node.email }}
                  </v-btn> -->

                        <!-- Delete Action -->
                        <v-list-item @click="deleteItem(item)">
                          <v-list-item-icon>
                            <v-icon>delete</v-icon>
                            <!-- Delete icon -->
                          </v-list-item-icon>
                          <v-list-item-title>Delete</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="editDialog" max-width="1200px">
      <v-card>
        <v-card-title>{{ formTitle }}</v-card-title>

        <v-card-text>
          <v-container fluid>
            <v-row dense>
              <v-col cols="4" sm="4">
                <v-text-field
                  v-model="editedItem.name"
                  label="Name"
                  :rules="[requiredRule, noSpacesRule]"
                  @input="sanitizeName"
                  dense
                />
              </v-col>
              <v-col cols="4" sm="4">
                <catValueDropDown
                  :outlined="true"
                  :catName="'COMMUNICAT_TYPE'"
                  v-model.trim="editedItem.type"
                  label="Communication type"
                  :rules="[requiredRule]"
                />
              </v-col>
              <v-col cols="4" sm="4">
                <catValueDropDown
                  :outlined="true"
                  :catName="'INDUSTRY'"
                  v-model.trim="editedItem.industry"
                  label="Industry"
                  :rules="[requiredRule]"
                />
              </v-col>
              <v-col cols="4" sm="4">
                <catValueDropDown
                  :outlined="true"
                  :catName="'MESSAGE_TEMPLATE_STATE'"
                  v-model.trim="editedItem.state"
                  label="State"
                  :rules="[requiredRule]"
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="editedItem.description"
                  label="Description"
                  auto-grow
                  rows="1"
                  no-resize
                  dense
                  :rules="[requiredRule]"
                />
              </v-col>

              <v-col>
                <v-text-field v-model="editedItem.subject" label="Subject" />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col>
                <quillEditor
                  v-model="editedItem.body"
                  :options="{ theme: 'snow' }"
                  label="Body"
                  style="min-height: 400px"
                  :rules="[requiredRule]"
                />
              </v-col>
              <v-col cols="1.5" sm="1.5">
                Available Variables
                <catValueDropDown
                  :outlined="true"
                  mode="list"
                  :catName="'MESSAGE_VARIABLES'"
                  v-model.trim="editedItem.industry"
                  label="Available Variables"
                  :rules="[requiredRule]"
                />
              </v-col>
              <!-- <v-col cols="12" md="6">
                <div
                  class="preview-pane"
                  v-html="sanitizedBody"
                  style="border: 1px solid #ccc; padding: 16px; min-height: 400px; overflow-y: auto;"
                />
              </v-col> -->
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="editDialog = false">Close</v-btn>
          <v-btn color="primary" @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="sendDialog" max-width="1200px">
  <v-card>
    <v-card-title>{{ formTitle }}</v-card-title>

    <v-card-text>
      <v-container fluid>
        <v-row dense>
          <v-col cols="12" sm="4">
            <v-text-field
              v-model="editedItem.name"
              label="Name"
              :rules="[requiredRule, noSpacesRule]"
              :disabled="true"
              dense
            />
          </v-col>

          <v-col cols="12" sm="4">
            <v-autocomplete
              v-model="selectedTeams"
              :rules="[requiredRule]"
              :items="teams"
              item-value="node.teamName"
              item-text="node.teamName"
              label="Select Group Name"
              multiple
              chips
              dense
            />
          </v-col>
          <v-col cols="12" sm="4">
            <v-autocomplete
              v-model="selectedGroupEmails"
              :rules="[requiredRule]"
              :items="groupEmails"
              item-value="node.email"
              :item-text="formatAthleteOption"
              label="Select Athlete Emails"
              multiple
              chips
              dense
            />
          </v-col>
          <v-col cols="12" sm="4">
            <catValueDropDown
              :outlined="true"
              :catName="'athlete_status'"
              :multiList="true"
              v-model.trim="selectedStatus"
              label="Athlete Status"
            />
          </v-col>

          <v-col cols="12" sm="4">
            <v-select
              v-model="competitiveFlag"
              :items="[
                { text: 'All Athletes', value: null },
                { text: 'Competitive Only', value: 1 },
                { text: 'Non-Competitive Only', value: 0 }
              ]"
              label="Competitive Filter"
              dense
              outlined
              clearable
            />
          </v-col>

        </v-row>
      </v-container>
    </v-card-text>

    <v-card-actions>
      <v-spacer />
      <v-btn text @click="sendDialog = false">Close</v-btn>
      <v-btn color="primary" @click="sendTemplate">Send</v-btn>
    </v-card-actions>

    <v-divider class="my-2" />

    <v-card-text>
      <h3 class="text-h6 mb-2">Message Preview</h3>
      <v-row dense>
        <v-col cols="12">
          <div
            class="preview-pane"
            v-html="sanitizedBody"
            style="border: 1px solid #ccc; padding: 16px; min-height: 300px; border-radius: 8px; background: #fafafa; overflow-y: auto;"
          />
        </v-col>
      </v-row>
    </v-card-text>

  </v-card>
</v-dialog>
</v-tab-item>

<!-- TAB 2: Communication -->
<v-tab-item>
  <v-card class="mt-4 pa-4">
    <Communications />
  </v-card>
</v-tab-item>
</v-tabs-items>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import DOMPurify from "dompurify";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import catValueDropDown from "../../shared/cat_val_dropdown.vue";
//import SendTemplateDialog from "./send-template-dialog.vue";
import Communications from "./PersonCommunications.vue";

export default {
  components: {
    quillEditor,
    catValueDropDown,
    Communications,
    //SendTemplateDialog,
  },
  data() {
    return {
      activeTab: 0, // 0 = Templates, 1 = Communication
      tabMap: {
        templates: 0,
        communication: 1,
      },
      loading: true,
      sendDialog: false,
      selectedStatus: ["test"],
      editDialog: false,
      editedIndex: -1,
      editedItem: {},
      selectedTeams: [],
      selectedGroupEmails: [],
      // selectedType: null,
      // selectedIndustry: null,
      competitiveFlag: null,
      teams: [],
      groupEmails: [],
      myClubOnly: false, // checkbox state
      currentClubId: this.$store.state.Clubs.club,
      createDuplicate: false,
      headers: [
        { text: "Actions", value: "actions", sortable: false },
        { text: "Name", value: "name" },
        { text: "Subject", value: "subject" },
        { text: "Description", value: "description" },
        { text: "Type", value: "type" },
        { text: "Body", value: "body", sortable: false },
        { text: "Industry", value: "industry" },
        { text: "Club Id", value: "clubId" },
        // { text: "League Id", value: "leagueId" },
        { text: "State", value: "state" },
        { text: "Created", value: "createDate" },
        { text: "Updated", value: "updateDate" },
      ],
      templates: [],
    };
  },
  computed: {
    ...mapGetters(["user", "allMessageTemplates", "clubInfo"]),
    selectedType: {
      get() {
        return this.$route.query.type || null;
      },
      set(value) {
        const query = { ...this.$route.query, type: value || undefined };
        this.$router.replace({ query });
      },
    },
    selectedIndustry: {
      get() {
        return this.$route.query.industry || null;
      },
      set(value) {
        const query = { ...this.$route.query, industry: value || undefined };
        this.$router.replace({ query });
      },
    },
    selectedState: {
      get() {
        return this.$route.query.state || null;
      },
      set(value) {
        const query = { ...this.$route.query, state: value || undefined };
        this.$router.replace({ query });
      },
    },
  clubId() {
    const id = this.$store.state.Clubs.club;
    return id !== 'undefined' && id !== undefined ? id : null;
  },
    filteredTemplates() {
      return this.templates.filter((t) => {
        const typeMatches = this.selectedType
          ? t.type === this.selectedType
          : true;
        const industryMatches = this.selectedIndustry
          ? t.industry === this.selectedIndustry
          : true;
        const stateMatches = this.selectedState
          ? t.state === this.selectedState
          : true;
        const clubMatches = this.myClubOnly && this.clubId
          ? t.clubId == this.clubId
          : true;
          //: t.clubId == this.clubId || t.clubId === null; // timely clubId population must be fixed
        return typeMatches && industryMatches && stateMatches && clubMatches;
      });
    },
    uniqueTypes() {
      return [...new Set(this.templates.map((t) => t.type))];
    },
    uniqueIndustry() {
      return [...new Set(this.templates.map((t) => t.industry))];
    },
    uniqueState() {
      return [...new Set(this.templates.map((t) => t.state))];
    },
    formTitle() {
      return this.editedIndex === -1
        ? "New Message Template"
        : "Edit Message Template";
    },
    sanitizedBody() {
      return DOMPurify.sanitize(this.editedItem.body || "");
    },
  },
  watch: {
    selectedTeams() {
      this.groupEmails = this.getSelectedGroupEmails();
    },
    selectedStatus() {
      this.groupEmails = this.getSelectedGroupEmails();
    },
    allMessageTemplates: {
      handler(val) {
        this.templates = val.edges.map((e) => e.node);
      },
      immediate: true,
      deep: true,
    },
  },
  async created() {
    await this.$store.dispatch("allMessageTemplates");
    this.loading = false;
  },
  methods: {
    formatAthleteOption(item) {
      return `${item.firstName} ${item.lastName} (${item.email})`;
    },
    navigateToTab(tabName) {
      const index = this.tabMap[tabName];
      if (index !== undefined) {
        this.activeTab = index;
        this.$router.replace({ query: { ...this.$route.query, tab: tabName } });
      }
    },
    openEditDialog(item) {
      console.log(item);
      this.editedIndex = item
        ? this.templates.findIndex((t) => t.seqNo === item.seqNo)
        : -1;
      this.editedItem = item
        ? { ...item }
        : {
            seqNo: 0,
            name: "",
            subject: "",
            body: "",
            description: "",
            type: "Email",
            state: "draft",
            industry: "SPORT",
            createDate: new Date().toISOString().split("T")[0],
            updateSource: this.user.userName,
          };
      this.editDialog = true;
    },
    duplicateTemplate(item) {
      this.createDuplicate = true;
      item.name = item.name + "_copy1";
      item.seqNo = 0;      
      this.openEditDialog(item);      
    },

    openSendDialog(item) {
      this.teams = this.clubInfo.edges.filter(
        (item) => item.node.clubId == this.$route.params.club
      )[0].node.team.edges;

      this.editedIndex = item
        ? this.templates.findIndex((t) => t.seqNo === item.seqNo)
        : -1;
      this.editedItem = item
        ? { ...item }
        : {
            seqNo: 0,
            name: "",
            subject: "",
            body: "",
            description: "",
            type: "Email",
            state: "draft",
            industry: "SPORT",
            createDate: new Date().toISOString().split("T")[0],
            updateSource: this.user.userName,
          };
      this.sendDialog = true;
    },
    getSelectedGroupEmails() {
      const selectedGroupEmails = [];

      if (!this.teams || !Array.isArray(this.teams)) return selectedGroupEmails;

      this.teams.forEach((teamEdge) => {
        const team = teamEdge.node;

        // Match selected team names (like 'Junior1', etc.)
        if (
          this.selectedTeams.includes(team.teamName) &&
          team.athlete.edges.length
        ) {
          team.athlete.edges.forEach((athleteEdge) => {
            const athlete = athleteEdge.node;
            const email = athlete.email;
            const status = athlete.status;

            if (email && this.selectedStatus.includes(status)) {
              selectedGroupEmails.push({
                email,
                firstName: athlete.firstName,
                lastName: athlete.lastName,
              });
            }
          });
        }
      });

      return selectedGroupEmails;
    },

    async save() {
      const payload = { ...this.editedItem };
      if (!payload.seqNo) delete payload.seqNo;

      payload.updateSource = this.user.userName;
      if (this.createDuplicate){
          payload.seqNo = 0
          payload.clubId = this.clubId;
          this.createDuplicate = false;
          //payload.name = payload.name + "_copy1"
      }
      console.log(payload);
      await this.$store.dispatch("messageTemplatesMerge", payload);
      this.editDialog = false;
      await this.$store.dispatch("allMessageTemplates");
    },
    async sendTemplate() {
      if (!this.selectedTeams.length && !this.selectedStatus.length) {
        this.$toast.error("Please select at least one team or one status.");
        return;
      }

      this.loading = true;

      const payload = {
        jobName: "email_job",
        jobParams: {
          clubName: "Rocket Swim Club",
          competitiveFlag: this.competitiveFlag,
          groups: this.selectedTeams,
          status: this.selectedStatus,
          emailTemplate: this.editedItem.name || "welcome",
          emailList: this.selectedGroupEmails || "support@sportecos.com",
        },
      };
      try {
        const response = await this.$store.dispatch("triggerJob", payload);

        if (response.success) {
          this.$toast.success("Template sent successfully!");
        } else {
          this.$toast.error("Failed: " + response.message);
        }
      } catch (error) {
        console.error(error);
        this.$toast.error("Error sending template.");
      } finally {
        this.loading = false;
        const confirmed = window.confirm(
          "Do you want to continue to the Communication tab?"
        );
        if (confirmed) {
          this.navigateToTab("communication");
        }
      }
    },
    truncateText(text, length) {
      return text && text.length > length
        ? text.substring(0, length) + "..."
        : text;
    },
    stripHtml(html) {
      return DOMPurify.sanitize(html, { ALLOWED_TAGS: [] });
    },
    requiredRule(v) {
      return !!v || "Name is required";
    },
    noSpacesRule(v) {
      return /^\S*$/.test(v) || "No spaces allowed";
    },
    sanitizeName() {
      // This will immediately remove any spaces while typing
      this.editedItem.name = this.editedItem.name.replace(/\s/g, "");
    },
    deleteItem(item) {
      if (confirm("Are you sure you want to delete this item?")) {
        this.$store.dispatch("messageTemplatesDelete", {
          seqNo: item.seqNo,
        });
      }
    },
  },
  mounted() {
    const tabName = this.$route.query.tab;
    this.activeTab =
      this.tabMap[tabName] !== undefined ? this.tabMap[tabName] : 0;
  },
};
</script>

<style scoped>
.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.preview-pane {
  background: #fafafa;
  border-radius: 8px;
}
</style>
